import clsx from 'clsx';
import { CheckCircle2, EyeOff } from 'lucide-react';
import styles from '../Toast.module.scss';
import { ReactComponent as Success } from '../../../../../assets/svg/icons/green_success.svg';
import { ReactComponent as Worker } from '../../../../../assets/svg/icons/poltrona.svg';
import { ReactComponent as Scissors } from '../../../../../assets/svg/icons/forbici.svg';
import { ReactComponent as Client } from '../../../../../assets/svg/icons/profilo.svg';
import { ReactComponent as Payment } from '../../../../../assets/svg/icons/portafogli.svg';
import { ReactComponent as Api } from '../../../../../assets/svg/icons/campanella.svg';

export const GeneralToast = ({ booking, type }) => {
  const title = {
    service: 'Servizi!',
    worker: 'Poltrone!',
    client: 'Clienti!',
    payment: 'Pagamenti!',
  };

  const variant = booking?.variant;
  const isMovedVariant = variant === 'movedHidden' || variant === 'movedActive';

  let Icon;
  switch (true) {
    case variant === 'movedHidden':
      Icon = EyeOff;
      break;
    case variant === 'movedActive':
      Icon = CheckCircle2;
      break;
    case type === 'service':
      Icon = Scissors;
      break;
    case type === 'worker':
      Icon = Worker;
      break;
    case type === 'client':
      Icon = Client;
      break;
    case type === 'payment':
      Icon = Payment;
      break;
    case type === 'api':
      Icon = Api;
      break;
    default:
      Icon = Success;
  }

  const toastTitle = type !== 'api' ? title[type] : booking.title;
  const toastBody = type !== 'api' ? booking.title : booking.message;

  return (
    <div
      className={clsx(styles.container_toast, {
        [styles.container_toast_movedHidden]: variant === 'movedHidden',
        [styles.container_toast_movedActive]: variant === 'movedActive',
      })}
    >
      <div className={styles.toast_header}>
        {isMovedVariant ? (
          <span className={styles.toast_icon_wrap} aria-hidden="true">
            <Icon className={styles.toast_icon} size={18} strokeWidth={2.4} />
          </span>
        ) : (
          <Icon className={styles.toast_icon} />
        )}
        <div className={styles.toast_text_block}>
          <p className={styles.toast_title}>{toastTitle}</p>
          {toastBody ? <p className={styles.toast_body}>{toastBody}</p> : null}
        </div>
      </div>
    </div>
  );
};
